//获取列表的高度
export const getTableHeight = height => {
  let tableHeight
  if (window.innerHeight - height <= 300) {
    tableHeight = 300
  } else {
    tableHeight = window.innerHeight - height
  }
  return tableHeight
}

// 计算两个日期中所有的日期
export const getDaysBetween = (start, end) => {
  //初始化日期列表，数组
  let diffDate = new Array()
  let i = 0
  //开始日期小于等于结束日期,并循环
  while (start <= end) {
    diffDate[i] = start
    //获取开始日期时间戳
    let stime_ts = new Date(start).getTime()
    //增加一天时间戳后的日期
    let next_date = stime_ts + (24 * 60 * 60 * 1000)
    //拼接年月日，这里的月份会返回（0-11），所以要+1
    let next_dates_y = new Date(next_date).getFullYear() + '-'
    let next_dates_m = (new Date(next_date).getMonth() + 1 < 10) ? '0' + (new Date(next_date).getMonth() + 1) + '-' : (new Date(next_date).getMonth() + 1) + '-'
    let next_dates_d = (new Date(next_date).getDate() < 10) ? '0' + new Date(next_date).getDate() : new Date(next_date).getDate()
    start = next_dates_y + next_dates_m + next_dates_d
    //增加数组key
    i++
  }
  return diffDate
}

export const htmlDecode = html => {
  const div = document.createElement('div')
  div.innerHTML = html
  return div.innerText
}

//把utc 日期转为当前时区的日期
export const convertToCurrentTimezone = (utcTime,separator,type) => {
  const utcDate = new Date(utcTime.replace(/\//g, '-') + 'Z');
  const localDate = new Date(utcDate.getTime() );
  const year = localDate.getFullYear();
  const month = ('0' + (localDate.getMonth() + 1)).slice(-2);
  const day = ('0' + localDate.getDate()).slice(-2);
  const hours = ('0' + localDate.getHours()).slice(-2);
  const minutes = ('0' + localDate.getMinutes()).slice(-2);
  const localTimeStr = type == 'datetime' ? `${year}${separator}${month}${separator}${day} ${hours}:${minutes}` : `${year}${separator}${month}${separator}${day}`;
  // console.log(localTimeStr);
  return localTimeStr
}

export const convertToUTC  = (date,type) =>{
  const localDate = new Date(date);
  const year = localDate.getUTCFullYear();
  const month = ('0' + (localDate.getUTCMonth() + 1)).slice(-2);
  const day = ('0' + localDate.getUTCDate()).slice(-2);
  const hours = ('0' + localDate.getUTCHours()).slice(-2);
  const minutes = ('0' + localDate.getUTCMinutes()).slice(-2);
  const seconds = ('0' + localDate.getUTCSeconds()).slice(-2);
  let dateTime =  type == 'datetime' ? `${year}-${month}-${day} ${hours}:${minutes}` : `${year}-${month}-${day}`;
  return dateTime
}
